export class LabelType {
  id: number;
  name: string;
  width: number;
  height: number

  constructor() {
    this.id = 0;
    this.name = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/+core/common/model/label-type.model.ts